import service from '@/utils/axios'

/**
 * 获取住枫桥code
 */
export function exchangeZfqCode(dada) {
  return new Promise((resolve, reject) => {
    service
      .post(`/user-proxy/api/zfq/exchange-code`, dada)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
